export default __webpack_public_path__ + "static/diamaticLogotype-95e4c3055afaf2b8890563a39f7d25c3.svg";